import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var validator = require('validator');

import { checkIfEmailAvailable } from '../redux/modules/contract';

var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};

var join = function join(rules) {
  return function (value, data, params) {
    return rules.map(function (rule) {
      return rule(value, data, params);
    }).filter(function (error) {
      return !!error;
    })[0];
  };
};

export function email(value) {
  if (!isEmpty(value) && !validator.isEmail(value)) {
    return 'Invalid email address';
  }

  return undefined;
}
export function required(value) {
  if (isEmpty(value)) {
    return 'Required';
  }

  return undefined;
}
export function minLength(min) {
  return function (value) {
    if (!isEmpty(value) && value.length < min) {
      return "Must be at least ".concat(min, " characters");
    }

    return undefined;
  };
}
export function maxLength(max) {
  return function (value) {
    if (!isEmpty(value) && value.length > max) {
      return "Must be no more than ".concat(max, " characters");
    }

    return undefined;
  };
}
export function integer(value) {
  if (!isEmpty(value) && !Number.isInteger(Number(value))) {
    return 'Must be an integer';
  }

  return undefined;
}
export function oneOf(enumeration) {
  return function (value) {
    if (enumeration.indexOf(value) === -1) {
      return "Must be one of: ".concat(enumeration.join(', '));
    }

    return undefined;
  };
}
export function match(field) {
  return function (value, data) {
    if (data) {
      if (value !== data[field]) {
        return 'Do not match';
      }
    }

    return undefined;
  };
}
export function createValidator(rules, params) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var errors = {};
    Object.keys(rules).forEach(function (key) {
      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions

      var error = rule(data[key], data, _objectSpread({
        key: key
      }, params));

      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

export function asyncValidate(_x, _x2) {
  return _asyncValidate.apply(this, arguments);
}

function _asyncValidate() {
  _asyncValidate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, dispatch) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(checkIfEmailAvailable(value.email));

          case 2:
            result = _context.sent;
            return _context.abrupt("return", sleep(1000).then(function () {
              // simulate server latency
              if (!result.data.emailAvailable) {
                throw {
                  email: "".concat(value.email, " is already in use.")
                };
              }
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _asyncValidate.apply(this, arguments);
}